



















































































































































































































































































































































































































































































































































/* eslint-disable camelcase */
/* eslint-disable quote-props */
import { defineComponent, reactive, ref, onMounted } from '@vue/composition-api'
import axios from 'axios'
import jsonToFormData from 'json-form-data'
import FloatingLabel from '@/components/FloatingLabel.vue'
import TextBox from '@/components/TextBox.vue'
import Captcha from '@/components/Captcha.vue'
import { pushForm, formStart } from '@/inc/utils/tracking'

interface FormField {
  condition?: {
    field: string
    value: string
  }
}

export default defineComponent({
  name: 'security-report-form',
  components: {
    FloatingLabel,
    TextBox,
    Captcha,
  },
  props: {
    form: {
      required: true,
      type: Object,
    },
    missingCaptcha: {
      type: String,
    },
    formSubmissionError: {
      type: String,
    },
    formSubmissionSuccess: {
      type: String,
    },
    id: {
      required: false,
    },
  },

  setup(props, ctx) {
    const formRef = ref()
    const captcha = ref()
    const isLoading = ref(false)
    const feedbackSuccess = ref('')
    const feedbackFailure = ref('')

    const nameInputRef = ref()
    const organisationInputRef = ref()
    const emailInputRef = ref()
    const phoneInputRef = ref()
    const productInputRef = ref()
    const descriptionInputRef = ref()
    const gdprInputRef = ref()

    const data = reactive({
      reportType: '',
      name: '',
      organisation: '',
      email: '',
      phone: '',
      product: '',
      observedAt: '',
      impacts: [] as string[],
      description: '',
      'g-recaptcha-response': '',
      form_id: props.form.formId,
      action: 'form',
      gdpr: false,
    })

    onMounted(() => {
      formStart(formRef.value)
    })

    // A field carrying a `condition` is only shown when the field it depends on
    // holds the expected value (phone is asked for an ongoing incident only)
    const isVisible = (field: FormField) =>
      !field.condition ||
      (data as Record<string, unknown>)[field.condition.field] ===
        field.condition.value

    const validateCaptcha = () => data['g-recaptcha-response']

    const onSubmit = () => {
      pushForm('click')
      feedbackSuccess.value = ''
      feedbackFailure.value = ''

      if (!validateCaptcha()) {
        feedbackFailure.value =
          props.missingCaptcha || 'Veuillez remplir le captcha.'

        return
      }

      isLoading.value = true
      submitForm()
    }

    const submitForm = () => {
      // Drop the phone number when it does not apply, it would only pollute the entry
      const payload = {
        ...data,
        phone: isVisible(props.form.fields.phone || {}) ? data.phone : '',
      }
      const formData = jsonToFormData(payload)

      axios
        .post(`${props.form.endpoint}?action=form`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(response => {
          if (response.data.status === 200) {
            success()
          } else {
            failure(response)
          }
        })
        .catch(error => {
          failure(error)
        })
        .finally(() => {
          isLoading.value = false
        })
    }

    const success = () => {
      feedbackSuccess.value =
        props.formSubmissionSuccess ||
        'Votre signalement a bien été transmis à notre équipe sécurité.'

      pushForm('success')
      resetForm()

      window.setTimeout(() => {
        ctx.emit('submit')
      }, 2500)
    }

    const failure = error => {
      resetCaptcha()

      feedbackFailure.value =
        props.formSubmissionError ||
        // eslint-disable-next-line quotes
        "Une erreur est survenue lors de l'envoi de votre signalement."

      pushForm('error')
      console.error(error)
    }

    const resetCaptcha = () => {
      data['g-recaptcha-response'] = ''
      captcha.value.reset()
    }

    const resetForm = () => {
      data.reportType = ''
      data.observedAt = ''
      data.impacts = []
      data.gdpr = false
      nameInputRef.value?.reset()
      organisationInputRef.value?.reset()
      emailInputRef.value?.reset()
      phoneInputRef.value?.reset()
      productInputRef.value?.reset()
      descriptionInputRef.value?.reset()
      resetCaptcha()
    }

    return {
      formRef,
      captcha,
      data,
      isLoading,
      feedbackSuccess,
      feedbackFailure,
      isVisible,
      onSubmit,
      nameInputRef,
      organisationInputRef,
      emailInputRef,
      phoneInputRef,
      productInputRef,
      descriptionInputRef,
      gdprInputRef,
    }
  },
})
